import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
moment.locale('pt-br');

@Pipe({
  name: 'dateBRPlanPrice'
})
export class DateBRPlanPricePipe implements PipeTransform {
  transform(date: moment.Moment | string | number): string {
    return moment(date).format('DD/MM/YYYY');
  }
}
